"use client";
import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ProductDetailsProvider } from '../../context/ProductDetailsContext';
import Header from '../Header';
import CategoryNav from '../CategoryNav';
import ProductGallery from './ProductGallery';
import ProductInfo from './ProductInfo';
import TabbedContent from './TabbedContent';
import ProductReviews from './ProductReviews';
import ProductSuggestions from './ProductSuggestions';

import FooterSection from '../Footersection';

function ProductDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Navigation handlers
  const handleHomeClick = () => {
    navigate('/');
  };

  const handleProductsClick = () => {
    navigate('/products');
  };

  return (
    <ProductDetailsProvider productId={id}>
      <div className="overflow-hidden bg-white">
        <Header />
        {/* <CategoryNav /> */}

        <main className="flex flex-col w-full">
          {/* Breadcrumb */}
          <nav className="px-4 md:px-8 lg:px-12 text-sm font-medium text-stone-300" aria-label="Breadcrumb">
            <div className="flex flex-col items-start pt-14 pb-2 w-full">
              <ol className="flex flex-wrap">
                <li className="flex flex-col items-start pr-2 pb-1.5 text-sm">
                  <button
                    onClick={handleHomeClick}
                    className="flex items-start hover:text-stone-400 focus:outline-none focus:text-stone-400 cursor-pointer transition-colors"
                    aria-label="Navigate to home"
                  >
                    <span style={{color: 'rgba(202,202,202,1)'}}>Home </span>
                    <span style={{fontWeight: 400, color: 'rgba(202,202,202,1)'}}>/</span>
                  </button>
                </li>
                <li className="flex flex-col items-start pr-2 pb-1.5">
                  <button
                    onClick={handleProductsClick}
                    className="flex items-start hover:text-stone-400 focus:outline-none focus:text-stone-400 cursor-pointer transition-colors"
                    aria-label="Navigate to products"
                  >
                    <span style={{color: 'rgba(202,202,202,1)'}}>Products </span>
                    <span style={{fontWeight: 400, color: 'rgba(202,202,202,1)'}}>/</span>
                  </button>
                </li>
                
              </ol>
            </div>
          </nav>

          {/* Product Section */}
          <section className="flex z-10 flex-wrap justify-center items-start min-h-[750px] px-4 md:px-8 lg:px-12 gap-4 md:gap-8">
            <ProductGallery />
            <ProductInfo />
          </section>

          {/* Tabbed Content */}
          <div className="px-4 md:px-8 lg:px-12">
            <TabbedContent />
          </div>

          {/* Product Reviews */}
          <div className="px-4 md:px-8 lg:px-12 mt-8">
            <ProductReviews />
          </div>

          {/* Product Suggestions */}
          <div className="px-4 md:px-8 lg:px-12 mt-4 ">
            <ProductSuggestions />
          </div>
        </main>
        <FooterSection />
      </div>
    </ProductDetailsProvider>
  );
}

export default ProductDetailsPage;
